import React, { useState } from "react";
import { formatAmount } from "../../../utils/format.js";
import RCAgingModal from "./RCAgingModal.jsx";
import DealerPendingReceiptModal from "./DealerPendingReceiptModal.jsx";
import AgingButton from "./AgingButton.jsx";
import { useSelector } from "react-redux";

const DealerLedger = ({ caseDetails, statuses, substatuses, RCLimit }) => {
  const InventoryData = {};
  const initialState = {
    aging: "",
    showRCAgingModal: false,
    showDealerPendingReceiptModal: false,
  };
  const [state, setState] = useState(initialState);
  const detailsStore = useSelector((state) => state.details);

  const InventoryTemplate =
    InventoryData.inv_status === "T" &&
    InventoryData.inv_details &&
    InventoryData.inv_details.outstanding > 0 ? (
      <>
        <span className="fa fa-inr  col-red">
          {InventoryData.inv_details.outstanding}{" "}
        </span>

        <button className="ic_info" title="Inventory Details">
          <img
            src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
            alt=""
          />
        </button>
        <div
          className="details_tooltip_wrapper car-details-tooltip"
          style={{ display: "none" }}
        >
          <div className="x_panel">
            <div className="x_title">
              <h2>Inventory Details</h2>
              <div className="clearfix"></div>
            </div>
            <div className="x_content">
              <div className="row">
                <div className="col-md-4 col-sm-3">
                  <div className="form-group">
                    <label className="label_text">Outstanding</label>
                    <div className="casedetailTxt clearfix" title="">
                      {" "}
                      <span className="hiddenText fa fa-inr">
                        {InventoryData.inv_details.outstanding}
                      </span>{" "}
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-3">
                  <div className="form-group">
                    <label className="label_text">GCD Code</label>
                    <div className="casedetailTxt clearfix" title="">
                      {" "}
                      <span className="hiddenText">
                        {InventoryData.inv_details.gcd_id}
                      </span>{" "}
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-3">
                  <div className="form-group">
                    <label className="label_text">Organization</label>
                    <div className="casedetailTxt clearfix">
                      {InventoryData.inv_details.organization}{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    ) : (
      <>
        <span className="fa fa-inr  col-red"></span>--
      </>
    );

  return (
    <span>
      <RCAgingModal
        dealer_id={caseDetails.dealer_id}
        aging={state.aging}
        rcAgentName={caseDetails.rcAgentName}
        statuses={statuses}
        substatuses={substatuses}
        closeRCAgingModal={() =>
          setState({ ...state, showRCAgingModal: false })
        }
        showRCAgingModal={state.showRCAgingModal}
      />

      <DealerPendingReceiptModal
        dealer_id={caseDetails.dealer_id}
        statuses={statuses}
        substatuses={substatuses}
        closeDealerPendingReceiptModal={() =>
          setState({ ...state, showDealerPendingReceiptModal: false })
        }
        showDealerPendingReceiptModal={state.showDealerPendingReceiptModal}
      />

      <div className="col-sm-4 border-dashed-r" id="dealer_ledger">
        <h3 className="panel-title">
          Dealer Ledger(
          {caseDetails.is_digital_dealer === 1 ? "Digital" : "Non-Digital"})
        </h3>
        <table className="table ledgerTable">
          <tbody>
            {!caseDetails.dealer_rc_count && !caseDetails.dealer_rc_amount ? (
              <tr>
                <td width="45%">
                  <div className="caseTxt">Original Pending</div>
                  <div className="casedetailTxt">
                    {RCLimit.original_pending ? RCLimit.original_pending : 0}
                  </div>
                </td>
                <td width="30%">
                  <div className="caseTxt">Transfer Pending</div>
                  <div className="casedetailTxt">
                    {RCLimit.transfer_pending ? RCLimit.transfer_pending : 0}
                  </div>
                </td>
                <td width="35%">
                  <div className="caseTxt">
                    Inventory Details
                    {caseDetails.id > 0 && (
                      <span
                        className="refreshInvDetail"
                        rel={caseDetails.id}
                        data-status={caseDetails.regno}
                        lang=""
                        data-shorting="ASC"
                        title="Refresh"
                        style={{ cursor: "pointer" }}
                      >
                        <i className="fa fa-refresh"></i>
                      </span>
                    )}
                  </div>
                  <div className="casedetailTxt">{InventoryTemplate}</div>
                </td>
              </tr>
            ) : (
              <tr>
                <td width="45%">
                  <div className="caseTxt">
                    RC Amount {RCLimit.is_adhoc_applicable ? "(Adhoc)" : ""}
                  </div>
                  <div className="casedetailTxt">
                    {RCLimit.rc_amount ? RCLimit.rc_amount : "--"}
                  </div>
                </td>
                <td width="30%">
                  <div className="caseTxt">RC Limit</div>
                  <div className="casedetailTxt">
                    {RCLimit.rc_no ? RCLimit.rc_no : "--"}
                  </div>
                </td>
                <td width="35%">
                  <div className="caseTxt">
                    Inventory Details
                    {caseDetails.id > 0 && (
                      <span
                        className="refreshInvDetail"
                        rel=""
                        data-status=""
                        lang=""
                        data-shorting="ASC"
                        title="Refresh"
                        style={{ cursor: "pointer" }}
                      >
                        <i className="fa fa-refresh"></i>
                      </span>
                    )}
                  </div>
                  <div className="casedetailTxt">{InventoryTemplate}</div>
                </td>
              </tr>
            )}

            <tr></tr>
            <tr>
              <td width="45%">
                <div className="caseTxt">Aging (Days)</div>
                <div className="casedetailTxt">
                  <AgingButton state={state} setState={setState} aging="0-60" />
                  <AgingButton
                    state={state}
                    setState={setState}
                    aging="60-90"
                  />
                  <AgingButton state={state} setState={setState} aging=">90" />
                </div>
              </td>
              <td width="30%">
                <div className="caseTxt" style={{ display: "block" }}>
                  Pending Payment
                </div>
                <div
                  className="caseTxt"
                  style={{
                    display: "block",
                    fontSize: "14px",
                  }}
                >
                  <span className="fa fa-inr"></span>
                  {RCLimit.pending_payment
                    ? formatAmount(RCLimit.pending_payment)
                    : 0}
                </div>
              </td>
              <td width="35%">
                <div className="caseTxt">
                  Category
                  <button
                    className="ic_info"
                    title="Pending Rto Receipt"
                    onClick={(e) => {
                      setState({
                        ...state,
                        showDealerPendingReceiptModal: true,
                      });
                      e.stopPropagation();
                    }}
                    disabled={detailsStore.formLoading}
                  >
                    <img
                      src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
                      alt=""
                    />
                  </button>
                </div>
                <div className="casedetailTxt">
                  {caseDetails.dealer_category}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </span>
  );
};

export default DealerLedger;
